// import investmentProducts from './pages/services/investment-products.json';
import refining from './pages/services/refining.json';
import estateLiquidation from './pages/services/estate-liquidation.json';
import commercialPurchasing from './pages/services/commercial-purchasing.json';

export const serviceList = [refining, estateLiquidation, commercialPurchasing];

export default serviceList;